import * as React from 'react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index-v2.css';
import * as Sentry from '@sentry/browser';
import {
  AllEnterpriseModule,
  LicenseManager,
  ModuleRegistry,
  provideGlobalGridOptions,
} from 'ag-grid-enterprise';

import { AgChartsCommunityModule } from 'ag-charts-community';

if (process.env.REACT_APP_ENV !== 'prod') {
  console.log('Environment: ' + process.env.REACT_APP_ENV);
}

//configure sentry for capturing crash events in sentry.io
if (process.env.REACT_APP_ENV === 'prod') {
  Sentry.init({ dsn: 'https://a309f823dc26460c936fd85699ad5dc6@sentry.io/193926' });
} else if (process.env.REACT_APP_ENV === 'staging') {
  Sentry.init({ dsn: 'https://fcf5d4eafea145ae9edbc729ea4ef24a@sentry.io/208568' });
} else if (process.env.REACT_APP_ENV === 'test') {
  Sentry.init({ dsn: 'https://da6a95326ad94958aac2c977221d6b75@sentry.io/156374' });
}

ModuleRegistry.registerModules([AllEnterpriseModule.with(AgChartsCommunityModule)]);
// AG Grid: error #239 Theming API and CSS file-based themes are both used on the same page.
// The AG Grid Theming API is the default method of styling the grid. See the migration docs: https://www.ag-grid.com/react-data-grid/theming-migration/.
// Because no value was provided to the `theme` grid option, it defaulted to themeQuartz. However, the legacy CSS file (ag-grid.css) is also included and will cause styling issues.
// Either pass the string "legacy" to the theme grid option to retain legacy-style themes, or remove ag-grid.css from the page to rely solely on the Theming API.
// Mark all grids as using legacy themes
provideGlobalGridOptions({ theme: 'legacy' });

// Configure AG-GRID enterprise component\
LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-086970}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Zywave,_Inc.}_is_granted_a_{Multiple_Applications}_Developer_License_for_{3}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{25_June_2026}____[v3]_[01]_MTc4MjM0MjAwMDAwMA==dc2fe3fe0cdf97170df32e949ba00e45'
);

// Find the root element by its ID ('root') and render the App component using React 18's createRoot API
// StrictMode helps identify potential problems in the application during development
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
